module.exports = __webpack_public_path__ + "static/media/banner-full.2f793a82.png";